import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterSettingsModel, Grid, SearchSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { catchError } from 'rxjs';
import { UsuarioService } from 'src/app/autenticacao/usuario.service';
import { LHistoriaModeloDto } from 'src/app/dtos/modelos/historia-modelo-dto';
import { ToastService } from 'src/app/libs/toast/toast.service';
import { HistoriaModeloService } from 'src/app/servicos/historia-modelo.service';
import { ToolbarService } from 'src/app/utilitarios/toolbar.service';
import { ModalPesquisaService } from '../base-pesquisa/modal-pesquisa.service';

interface FiltroForm {
  ativo: FormControl<boolean>;
  meusModelos: FormControl<boolean>;
}

@Component({
  selector: 'app-historia-modelo-pesquisa',
  templateUrl: './historia-modelo-pesquisa.component.html',
  styleUrls: ['./historia-modelo-pesquisa.component.less'],
  providers: [ModalPesquisaService]
})
export class HistoriaModeloPesquisaComponent implements OnInit {

  @ViewChild('grid')
  grid!: Grid;

  @Output()
  registroSelecionado: EventEmitter<LHistoriaModeloDto> = new EventEmitter<LHistoriaModeloDto>();

  registros: Object | null = null;

  toolbarItens: Object[] = [
    { id: 'novo', text: 'Novo', prefixIcon: 'fal fa-plus' },
    { id: 'editar', text: 'Editar', prefixIcon: 'fal fa-edit' },
    { type: 'Separator' },
    'Search', 'ExcelExport', 'CsvExport', 'PdfExport'
  ];

  filterSettings: FilterSettingsModel = {
    mode: 'Immediate',
    type: 'Excel'
  }

  searchSettings: SearchSettingsModel = {
    ignoreAccent: true,
    ignoreCase: true
  }

  modelo: FormGroup<FiltroForm> = this.fb.nonNullable.group({
    ativo: [true],
    meusModelos: [false],
  });

  constructor(
    private fb: FormBuilder,
    private modalServico: ModalPesquisaService,
    public toast: ToastService,
    public toolbar: ToolbarService,
    private historiaModeloService: HistoriaModeloService,
    private usuarioService: UsuarioService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
  }

  recarregar() {
    this.pesquisar();
  }

  pesquisar() {
    const ativo = this.modelo.controls.ativo.value;
    const meusModelos = this.modelo.controls.meusModelos.value;

    let profissionalId: number | undefined = undefined;

    if (meusModelos) {
      const usuario = this.usuarioService.consultarUsuario();
      profissionalId = usuario.profissionalId;
    }

    const apenasAtivos = ativo ? true : undefined;
    const meus = meusModelos ? profissionalId : undefined;

    this.historiaModeloService.listar(meus, apenasAtivos)
      .pipe(
        catchError((err) => {
          this.toast.showError('Erro ao listar modelos de história clínica.');
          throw err;
        })
      )
      .subscribe((modelos) => {
        this.registros = modelos;
      });
  }

  toobarClick(args: ClickEventArgs) {
    if (args.item.id !== 'novo' && args.item.id !== 'editar')
      return;

    let registros = this.grid.getSelectedRecords() as LHistoriaModeloDto[];

    if (args.item.id === 'novo') {
      window.open(this.gerarUrl(), '_add_novo_modelo_historia');

    }
    else if (args.item.id === 'editar') {
      if (registros.length === 0) {
        this.toast.showInfo('Selecione um registro.');
        return;
      }
      window.open(this.gerarUrl(registros[0].id + ''), '_edit_modelo_historia');
    }
  }

  selecionado(registro: LHistoriaModeloDto) {
    this.registroSelecionado.next(registro);
  }

  abrir() {
    this.modalServico.abrirTelaCheia();
    this.pesquisar();
  }

  fechar() {
    this.modalServico.fechar();
  }

  gerarUrl(idText?: string) {
    let origin = window.location.origin;

    if (idText) {
      return origin + this.router.createUrlTree(['modelos/historias/cadastro', { id: idText }]).toString();
    }

    return origin + this.router.createUrlTree(['modelos/historias/cadastro']).toString();
  }
}
